/* This file is autogenerated, see readme.md for instructions */
import TrashSvgIcon from '@bloomreach/banana-theme/icons/trash.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TrashIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TrashSvgIcon />
    </Icon>
  );
});

TrashIcon.displayName = 'TrashIcon';

export default TrashIcon;
